import type { ConditionType, ConditionOperator } from '@/types/condition';
import styles from './ConditionBadge.module.css';

interface ConditionBadgeProps {
  type: ConditionType;
  operator: ConditionOperator;
  value: string;
  size?: 'sm' | 'md';
}

export function ConditionBadge({ type, operator, value, size = 'md' }: ConditionBadgeProps) {
  return (
    <span
      className={`${styles.badge} ${size === 'sm' ? styles.sm : styles.md}`}
      data-testid="condition-badge"
    >
      <span className={styles.type}>{type}</span>{' '}
      <span className={styles.operator}>{operator}</span>{' '}
      <span className={styles.value}>&ldquo;{value}&rdquo;</span>
    </span>
  );
}
